import { message as EeveeMessage } from '@fuxi/eevee-ui';
import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';
import { Comment, CommentSourceType } from '@/types';

const comments = {
  getReviews: async (
    taskId: number | string,
    versionId?: number | string,
    orderBy?: 'time' | 'frame',
    filterBy?: string,
  ) => {
    const params = { taskId, versionId, orderBy, filterBy };
    const {
      data: { reviewList = [] },
    } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v2/review/getReviews', {
      params,
    });
    return reviewList;
  },
  getHtmlReviews: async (taskId, versionId) => {
    const params = { ...getNormalParams('getHtmlReviews'), taskId, versionId };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/review/getHtmlReviews', {
      params,
    });
    return data;
  },
  deleteReview: async reviewId => {
    const { code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v1/review/deleteReview', {
      ...getNormalParams('deleteReview'),
      reviewId,
    });
    const hasError = code !== 0;
    if (hasError) {
      EeveeMessage.error(message || '删除反馈失败');
    } else {
      EeveeMessage.success('成功');
    }
    return code === 0;
  },
  addReview: async (versionFileId: number, taskId: number, comment: Partial<Comment>, type?: CommentSourceType) => {
    const formattedComment = {
      taskId: Number(taskId),
      versionFileId: Number(versionFileId),
      preview: comment.preview,
      type, // 注释反馈 or 画板反馈
      content: comment.content,
      annotation: JSON.stringify(comment.annotation),
      attachment: comment.attachment,
      assetPosition: JSON.stringify(comment.assetPosition),
    };
    return FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v2/review/addReview', formattedComment);
  },
  updateReview: async (params: { taskId: number; reviewId: number; comment: Partial<Comment> }) => {
    const { taskId, reviewId, comment } = params;
    const type = comment.type;
    const formattedComment = {
      taskId: Number(taskId),
      preview: comment.preview || {},
      type, // 注释反馈 or 画板反馈
      content: comment.content,
      annotation: JSON.stringify(comment.annotation),
      attachment: comment.attachment,
      assetPosition: JSON.stringify(comment.assetPosition),
      reviewId,
    };
    return FastApiAxiosInstance.post<any, ExtendAxioResponse<any>>('/api/v2/review/updateReview', {
      ...formattedComment,
    });
  },
};

export default comments;
